<template>
  <div>
    <div class="table_card mt-4">
      <div class="table_card__head">
        <p class="table_card__head--title">Crear Usuario</p>
      </div>

      <div class="table_card__body">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap>

            <v-flex xs6 style="padding: 8px">
              <label class="table_card__info--label">Foto</label>
              <div class="trainers__form--photo_container">
                <label for="trainerPhoto" class="faccess_button buttom_shadow px-5">Subir foto</label>
                <input id="trainerPhoto" type="file" accept="image/jpeg" @change="onFileChange" name="photo" />
              </div>
            </v-flex> 

            <v-flex xs6 style="padding: 8px">
              <div class="data_card__import_img" :style="{ backgroundImage: 'url(' + user_url_photo + ')' }"></div>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <v-text-field label="Número de documento:" v-model="user.rut" :rules="[rules.length]"
                required></v-text-field>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <v-select item-text="name" item-value="id" v-model="user.document_type" :items="document_types"
                label="Tipo de documento:"></v-select>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <v-text-field label="Nombre:" v-model="user.user_info_attributes.name" :rules="[rules.required]"
                required></v-text-field>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <v-text-field label="Apellido:" v-model="user.user_info_attributes.last_name" :rules="[rules.required]"
                required></v-text-field>
            </v-flex>

            <v-flex style="padding: 8px; display: flex; height: 60px;">
              <vue-country-code :default-country="user.country_phone_name" :enabled-country-code="true"
                @onSelect="selectCountry" />
              <v-text-field style="padding-left: 10px;" type="tel" label="Teléfono" v-model="user.mobile"
                :rules="[rules.length]" required></v-text-field>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <v-text-field label="Correo electrónico:" v-model="user.email" :rules="[rules.required]"
                required></v-text-field>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <v-text-field
                label="Categoría:"
                v-model="user.category"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <v-text-field
                label="pais:"
                v-model="user.nationality"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <label style="color: gray; font-size: 12px;">Género:</label>
              <v-radio-group v-model="user.user_info_attributes.gender" row>
                <v-radio label="Mujer" value="Femenino" color="#1476FB"></v-radio>
                <v-radio label="Hombre" value="Masculino" color="#1476FB"></v-radio>
              </v-radio-group>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <v-select
                v-model="user.plan"
                :items="user_categories"
                label="Plan de usuario:"
              ></v-select>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <v-menu v-model="menuBirthday" :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                <template v-slot:activator="{ on, attrs }" >
                  <v-text-field v-model="user.user_info_attributes.birthday" label="Fecha de nacimiento:" readonly
                    append-icon="today" v-bind="attrs" v-on="on" :rules="[rules.required]" required />
                </template>
                <v-date-picker v-model="user.user_info_attributes.birthday" @input="menuBirthday = false" />
              </v-menu>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                <template v-slot:activator="{ on, attrs }" style="min-width: 0;">
                  <v-text-field v-model="user.user_info_attributes.plan_from" label="Inicio del plan:" readonly
                    append-icon="today" v-bind="attrs" v-on="on" :rules="[rules.required]" required />
                </template>
                <v-date-picker v-model="user.user_info_attributes.plan_from" @input="menu = false" />
              </v-menu>
            </v-flex>

            <v-flex xs6 style="padding: 8px">
              <v-menu 
              ref="menuPlanUntil"
               v-model="menuPlanUntil" 
               :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field 
                  v-model="user.user_info_attributes.plan_until"
                  label="Fin del plan:" 
                    append-icon="today"
                        readonly
                        v-bind="attrs"
                        v-on="on"/>
                </template>
                <v-date-picker v-model="user.user_info_attributes.plan_until" @input="menuPlanUntil = false" />
              </v-menu>
            </v-flex>

            <v-flex xs6 style="padding: 8px" v-if="this.getCompany().access.invitation_approved">
              <v-select
                v-model="user.department"
                :items="approvalDepartments"
                label="Departamento"
              ></v-select>
            </v-flex>

          </v-layout>
        </v-form>
      </div>

      <div class="table_card__footer">
        <button type="button" @click="saveUserInfo()" class="faccess_button">Crear Usuario</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      valid: false,
      menu: false,
      menuBirthday: false,
      menuPlanUntil: false,
      user_url_photo: '',
      user_categories: [],
      document_types: [
        { id: "CD", name: "Carnet Diplomático" },
        { id: "cc", name: "Cédula de Ciudadanía" },
        { id: "CE", name: "Cédula de Extranjería" },
        { id: "PA", name: "Pasaporte" },
        { id: "RC", name: "Registro Civil" },
        { id: "TI", name: "Tarjeta de Identidad" }
      ],
      user: {
        rut: '',
        document_type: '',
        email: '',
        mobile: '',
        country_phone_code: '+57',
        country_phone_name: 'CO',
        category: 'A',
        nationality: '',
        plan: '',
        photo: '',
        department:'',
        user_info_attributes: {
          name: '',
          last_name: '',
          gender: 'Masculino',
          birthday: new Date().toISOString().substr(0, 10),
          user_category_id: '',
          plan_from: '',
          plan_until: ''
        }
      },
      rules: {
        required: value => !!value || 'Requerido',
        length: value => value.length > 5 || 'Mínimo 6 caracteres',
        match: value => value === this.user.password || 'Las contraseñas deben coincidir'
      },
      data_upload: [],
      base_64_data: null,
      files: [],
      approvalDepartments:[],

    };
  },
  methods: {
    selectCountry({ iso2, dialCode, name }) {
      this.user.country_phone_code = `+${dialCode}`;
      this.user.country_phone_name = iso2;
      this.user.nationality = name ? name.toLowerCase() : '';
    },

    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      const extension = file.name.split('.').pop().toLowerCase();
      const isValid = ['jpg', 'jpeg'].includes(extension);
      const isTooBig = file.size > 200 * 1024;

      if (!isValid || isTooBig) return;

      this.user_url_photo = URL.createObjectURL(file);

      const reader = new FileReader();
      reader.onload = () => {
        const base64data = reader.result;

        // Asignar al usuario
        this.user.photo = base64data;

      
      };
      reader.readAsDataURL(file);
    }
    ,

    validateForm() {
      const { rut, email } = this.user;
      const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
      return rut && email && emailRegex.test(email);
    },

    mapUserToPayload() {
      const u = JSON.parse(JSON.stringify(this.user)); // evitar reactividad de Vue
      const ui = u.user_info_attributes || {};

      const formatDate = (dateStr) => {
        if (!dateStr) return null;
        const date = new Date(dateStr);
        if (isNaN(date)) return null;
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };

      const wrap = (value) => [value != null ? value : ""];

      const orderedKeys = [
        "Rut",
        "Tipo de documento",
        "Email",
        "Nombre",
        "Apellido",
        "Pais indicativo",
        "Celular",
        "Genero",
        "Fecha de nacimiento",
        "Categoria",
        "Fecha inicio",
        "Fecha fin",
        "Nacionalidad",
        "Plan de usuario",
        "Departamento"
      ];

      const rawData = {
        "Rut": u.rut,
        "Tipo de documento": u.document_type,
        "Email": u.email,
        "Nombre": ui.name,
        "Apellido": ui.last_name,
        "Pais indicativo": u.nationality,
        "Celular": parseInt(u.mobile),
        "Genero": ui.gender,
        "Fecha de nacimiento": formatDate(ui.birthday),
        "Categoria": u.category,
        "Fecha inicio": formatDate(ui.plan_from),
        "Fecha fin": formatDate(ui.plan_until),
        "Nacionalidad": u.nationality,
        "Plan de usuario": u.plan,
        "Departamento":u.department,
      };


      // Crear el objeto final manteniendo el orden
      var orderedFormatted = {};
      orderedKeys.forEach((key) => {
        orderedFormatted[key] = [rawData[key]];
      });

      this.data_upload.push(orderedFormatted)
    }



    ,

    handleSuccess(response) {
      this.updateAlertMessage(response.body.ans);
      this.updateIsInAlert(true);
      if (response.body.meta.authentication_token) {
        this.checkToken(response.body.meta.authentication_token);
      }
      this.resetForm();
    },

    handleError(error) {
      const body = error.body || {};
      const msg = body.ans || body.errors[0].details || "Error desconocido";

      this.updateAlertMessage(msg);

    },

    resetForm() {
      this.valid = false;
      this.user_url_photo = '';
      // Opcional: vaciar campos de `user`
    },

    saveUserInfo() {
      if (!this.valid || !this.validateForm()) {
        this.updateAlertMessage("Formulario inválido. Revisa los campos obligatorios.");
        this.updateIsInAlert(true);
        return;
      }

      this.mapUserToPayload()


      let finalJson = { new: this.data_upload, company_id: this.getCompany().id }
      console.log(finalJson)

      try {

        this.$http.post('app/users/upload_user_or_create', {
          data: this.encrypt(finalJson).toString(),
          attributes: this.encrypt(finalJson).toString()
        },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              "Authorization": 'Bearer ' + this.getUserToken()
            }

          }).then(function (response) {
            setTimeout(() => { this.charge = true; }, 1000)
            this.uploadPhotos()
            this.updateAlertMessage(response.body.ans)
            this.updateIsInAlert(true);
            this.$router.push({ name: 'main_menu_page' });

            if (response.body.meta != undefined && response.body.meta != null) {
              if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function (response) {
            if (response.body.errors[0].title.includes("invalid input syntax for type date:")) {
             
              
              this.updateAlertMessage("Las fechas ingresadas en el archivo no tienen el formato correcto");
              this.updateIsInAlert(true);
            }
            this.updateAlertMessage(response.body.ans || response.body.errors[0].details);
            this.updateIsInAlert(true);
            if (response.body.errors[0].status == 500) {
              this.updateAlertMessage("Error de conexión. Verifica la conexión a internet o la energía del dispositivo.");
              this.updateIsInAlert(true);
            }
            if (response.body.meta != undefined && response.body.meta != null) {
              if (response.body.meta0authentication_token != undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
      }
      catch (e) {
        console.log(e)
        this.updateAlertMessage(e.message);
        this.updateIsInAlert(true);
      }
    },

    getUsersCategories() {
      
      try {
        const params = { company_id: this.getCompany().id };
        this.$http
          .get("user_categories/index", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params
          })
          .then(response => {
            this.usersCategories = response.body;
            this.user_categories = this.usersCategories.map(cat => cat.name);
            console.log(this.user_categories);
          });
      } catch (e) {
        alert(e.message);
        if (response.body.meta != undefined && response.body.meta != null) {
          if (
            response.body.meta.authentication_token != undefined &&
            response.body.meta.authentication_token != null
          ) {
            this.checkToken(response.body.meta.authentication_token);
          }
        }
      }
    },

    uploadPhotos() {

      if (!this.user.photo){  return}
        this.files = [
          {
            name: this.user.rut,
            base64data:  this.user.photo
          }
        ];
        console.log(this.files)

      let finalJson = { photos: this.files, company_id: this.getCompany().id }
      try {
        this.$http.post('app/users/import_photos', {
          data: this.encrypt(finalJson).toString(),
          attributes: this.encrypt(finalJson).toString()
        },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              "Authorization": 'Bearer ' + this.getUserToken()
            }

          }).then(function (response) {
            // this.charge = false;
            // this.$router.push({name: 'import_users'});
            this.files = []
            this.zipTitle = ""
            setTimeout(() => { this.charge = true; }, 1000)
            this.updateAlertMessage(response.body.ans);
            this.updateIsInAlert(true);

            if (response.body.meta != undefined && response.body.meta != null) {
              if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function (response) {
            console.log('response */*/*/*/**/', response.body.ans)
            this.updateAlertMessage(response.body.ans);
            this.updateIsInAlert(true);
            if (response.body.meta != undefined && response.body.meta != null) {
              if (response.body.meta0authentication_token != undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
      }
      catch (e) {
        alert(e.message)
      }
    },

     getApprovalDepartments() {
      const data = { company: { id: this.getCompany().id } };
      try {
        this.$http
          .get("approval_department", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params: {
              data: {
                user_id: this.getUserId(),
                company_id: this.getCompany().id
              }
              
            }
          })
          .then(function(response) {
            this.approvalDepartments = response.body.data.map(dep => dep.attributes.name);
            console.log(this.approvalDepartments)
          });
      } catch (e) {
        alert(e);
      }
    }
  },

  mounted() {
    this.getUsersCategories()
    if(this.getCompany().access.invitation_approved){
      this.getApprovalDepartments()
    }
  },
};
</script>

<style scoped>
.menuable__content__active{
    min-width: 0px !important;

  }

</style>



// WEBPACK FOOTER //
// src/components/views/users/NewUser.vue